
import { defineComponent, PropType} from "vue";
import { Company } from "@/models/Customer";
import { useAsyncSpinner } from "@/services/Spinner";
import { MemberApi } from "@/services/Api";

export default defineComponent({
  data() {
    return {
      selectedCompanyId: ""
    }
  },
  mounted() {
    if (this.companies.length > 0) {
      this.selectedCompanyId = this.companies[0].externalId;
    }
  },
  props: {
    companies: {
      type: Array as PropType<Array<Company>>,
      required: true
    },
    categoryurl: {
      type: String,
      required: false
    }
  },
  methods: {
    async onsubmit() {
      if (this.selectedCompanyId != null) {
        await useAsyncSpinner(async () => {
          await MemberApi.setCompany(this.selectedCompanyId);
          location.assign(window.location.origin + this.$props.categoryurl);
        });
      }
    }
  }
});
